import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D287 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D287 - Java Frameworks</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 10.30 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            This is the single most difficult course in this entire degree.
            There’s just no material, and you’re left on your own to fend for
            yourself.
          </p>
          <p>
            The only good part? There are 3 or 4 instructors that you can book
            appointments with pretty quickly, and they’re actually super
            helpful. They helped me diagnose my code pretty fast.
          </p>
          <p>
            Other than that, I followed this guide exactly—it’s very well
            written and made things way easier:
            <br />
            🔗{" "}
            <a href="https://www.reddit.com/r/WGU_CompSci/comments/15mocjz/d287_java_frameworks_ultimate_project_guide/" target="_blank" rel="noreferrer">
              D287 Java Frameworks Ultimate Project Guide
            </a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D287;
